export const NETWORKS = [

  {
    rpcUrl:
      "https://rpc.ankr.com/eth/0570bd39737b1fa76d31155bf0ca4102aacb19157697ffd5bcb141eb429eeffd",
    contractAddress: "0xeC1C3F3d7240ae35B174107689634b589797bF1C",
  },

  {
    rpcUrl:
      "https://rpc.ankr.com/bsc/0570bd39737b1fa76d31155bf0ca4102aacb19157697ffd5bcb141eb429eeffd",
    contractAddress: "0x755F9cB33b0AbB1d7b7EFD79D125C10C14a5aBFB",
  },
];

export const BASE_URL = "https://kindtrades.xyz/";

export const aggregatorV3ABI = [
  {
    inputs: [],
    name: "latestRoundData",
    outputs: [
      { internalType: "uint80", name: "roundId", type: "uint80" },
      { internalType: "int256", name: "answer", type: "int256" },
      { internalType: "uint256", name: "startedAt", type: "uint256" },
      { internalType: "uint256", name: "updatedAt", type: "uint256" },
      { internalType: "uint80", name: "answeredInRound", type: "uint80" },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export const feeds = {
  ethereum: {
    rpc: "https://rpc.ankr.com/eth/0570bd39737b1fa76d31155bf0ca4102aacb19157697ffd5bcb141eb429eeffd",
    tokens: {
      ETH: "0x5f4ec3df9cbd43714fe2740f5e3616155c5b8419",
    },
  },
  bsc: {
    rpc: "https://rpc.ankr.com/bsc/0570bd39737b1fa76d31155bf0ca4102aacb19157697ffd5bcb141eb429eeffd",
    tokens: {
      BNB: "0x0567f2323251f0aab15c8dfb1967e4e8a7d42aee",
    },
  },
  polygon: {
    rpc: "https://rpc.ankr.com/polygon/0570bd39737b1fa76d31155bf0ca4102aacb19157697ffd5bcb141eb429eeffd",
    tokens: {
      MATIC: "0xab594600376ec9fd91f8e885dadf0ce036862de0",
    },
  },
};

export const CHRLE_TOKEN_ADDRESS = "0x755F9cB33b0AbB1d7b7EFD79D125C10C14a5aBFB";
